import { apply, put, takeLatest, fetch } from '@ers/helpers/redux/sagaEffects';
import ApiFactory from '@ers/api/ApiFactory';
import AppApi from '../App.api';
import { ActionTypes,
    fetchApplicationDetailsCompleted, } from './Form.actions';


function* fetchApplicationDetails(api, action) {
    const { applicationId } = action.payload;
    const response = yield fetch(api, api.fetchApplicationDetails, [applicationId]);
    if (!response.error) {
        yield put(fetchApplicationDetailsCompleted(applicationId, response.data));
    }
}

export default function* formSaga() {
    const apiFactory = new ApiFactory();
    const api = yield apply(apiFactory, apiFactory.create);
    const appApi = new AppApi(api);
    yield takeLatest(ActionTypes.fetchApplicationDetails, fetchApplicationDetails, appApi);
}
